import { useRef } from 'react';
import { debounce } from 'lodash';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import connectedPageCRUDActions from '@mm/state/actions/ConnectedPageCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';

export const useDebouncedFetchSearchQuery = (wait = 800) => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return useRef(
    debounce(async (companyId: number, searchInput: string) => {
      await dispatch(
        connectedPageCRUDActions.retrieveBasicListByCompany(
          companyId,
          {
            withFacebookErrors: true,
            withSubscription: true,
            searchQuery: searchInput,
          },
          true,
        ),
      );
    }, wait),
  ).current;
};
